import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { GetPromptTemplatesResponse, PromptTemplate } from "@/types/agenticAI";

import { getPromptTemplates } from "./promptTemplatesApi";

export const useGetPromptTemplates = (
  topic: string,
  options?: Omit<
    UseQueryOptions<GetPromptTemplatesResponse, Error, PromptTemplate[]>,
    "queryKey" | "queryFn" | "select"
  >
) =>
  useQuery<GetPromptTemplatesResponse, Error, PromptTemplate[]>({
    queryKey: ["prompt-templates", topic],
    queryFn: () => getPromptTemplates(topic),
    select: (response) => response.data ?? [],
    ...options
  });
